import * as angular from 'angular';
import { MeurhAdmissoesestagiarioOutrasinformacoesFormController } from './outrasinformacoes.form.controller';

export class MeurhAdmissoesestagiarioOutrasinformacoesFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesestagiarioOutrasinformacoesFormComponent';
	static controller = MeurhAdmissoesestagiarioOutrasinformacoesFormController;
	static template = require('!!html-loader!./outrasinformacoes.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
